import {get} from "./thunks";
import {State} from "./types";
import {RequestStatus} from "interfaces";
import {initialState} from "./initial-state";
import {setRequestStatus} from "../request-status";
import {PayloadAction, createSlice} from "@reduxjs/toolkit";

export const credits = createSlice({
  name: "credits",
  initialState,
  reducers: {
    setCreditsSliceRequestStatus: function (
      state,
      action: PayloadAction<{
        name: keyof State["request"];
        status: RequestStatus;
      }>
    ) {
      const {name, status} = action["payload"];
      state["request"][name] = status;
    },
    setCreditsPagination: function (
      state,
      action: PayloadAction<State["pagination"]>
    ) {
      state["pagination"] = action["payload"];
    },
    clearCredits: function (state) {
      state["credits"] = [];
    },
  },
  extraReducers: function (builder) {
    builder.addCase(get.fulfilled, function (state, action) {
      const {data, refresh} = action["payload"];
      const {rows, count} = data;
      const nextRows = refresh ? rows : [...state["credits"], ...rows];
      state["credits"] = nextRows;
      state["request"]["credits"] = setRequestStatus("success");
      state["pagination"]["hasMore"] = nextRows["length"] < count;
    });
    builder.addCase(get.rejected, function (state) {
      state["request"]["credits"] = setRequestStatus("error");
    });
  },
});

export default credits["reducer"];
export const {
  clearCredits,
  setCreditsPagination,
  setCreditsSliceRequestStatus,
} = credits["actions"];
